module.exports = __webpack_public_path__ + "static/media/id_blob.f563542b.png";